module.exports = __webpack_public_path__ + "efda92703782a8708b5588ca6e5e66fa.jpg";